import React, {Component} from 'react'
import FJLinkPrompt from '../view/FJLinkPrompt'
import {connect} from 'react-redux'
import {FJMediaAction} from "../../../redux/action/FJRoot.action";

class FJLinkPromptContainer extends Component {

  render() {

    let {
      openLinkModal,
      active
    } = this.props;

    return (
      active ? <FJLinkPrompt onClick={openLinkModal} /> : null
    );
  }
}

const mapStateToProps = () => {
  return {
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    openLinkModal: function () {
      dispatch(FJMediaAction.openLinkModalByUser());
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJLinkPromptContainer);
